import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PageSizing } from '__components/Layout/PageContentWidth';
import { SmartConnectorContext } from '../../context';
import {
  StyledHeaderWrapper,
  StyledScopeSelect,
  StyledScopeSelectWrapper,
  StyledVariablesCard,
  StyledVariablesInfo,
} from './styles';
import { VariablesList } from './VariablesList';
import { SMART_CONNECTOR_STEPS } from '__pages/SmartConnectors/constants';
import { KizenTypography } from '__app/typography';
import { useScope } from '../../../hooks/useScope';
import { StyledLoader } from '../styles';

export const VariablesStep = () => {
  const { t } = useTranslation();
  const { setIsValid, smartConnector, loading } = useContext(
    SmartConnectorContext
  );

  const { scope, setScope, onChangeScope, scopeOptions } =
    useScope(smartConnector);

  useEffect(() => {
    setIsValid(true);
  }, [setIsValid]);

  return (
    <PageSizing>
      <StyledVariablesCard data-qa={`${SMART_CONNECTOR_STEPS.variables}-step`}>
        <StyledHeaderWrapper>
          <KizenTypography type="subheader">
            {t('Initialize Variables')}
          </KizenTypography>
          {scopeOptions.length > 1 ? (
            <StyledScopeSelectWrapper>
              <KizenTypography>{t('Scope:')}</KizenTypography>
              <StyledScopeSelect
                value={scope}
                options={scopeOptions}
                onChange={onChangeScope}
              />
            </StyledScopeSelectWrapper>
          ) : null}
        </StyledHeaderWrapper>
        <StyledVariablesInfo>
          {t(
            'Each of the variables specified below will be created and initialized to their respective values for each single contextual row of the spreadsheet. If any variable is marked as required and the variable is initialized to a missing or null value, the entire row will fail to process and be skipped.'
          )}
        </StyledVariablesInfo>
        <StyledLoader loading={loading}>
          <VariablesList scope={scope} setScope={setScope} />
        </StyledLoader>
      </StyledVariablesCard>
    </PageSizing>
  );
};
